module.exports = __webpack_public_path__ + "static/media/default-woman-inky.ec25f1ca.png";